import { render, staticRenderFns } from "./faqItemsList.vue?vue&type=template&id=0db10e18&scoped=true&"
import script from "./faqItemsList.vue?vue&type=script&lang=js&"
export * from "./faqItemsList.vue?vue&type=script&lang=js&"
import style0 from "./faqItemsList.vue?vue&type=style&index=0&id=0db10e18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db10e18",
  null
  
)

export default component.exports